import { useState, useEffect } from 'react';
import { Textarea } from './Textarea';
import { Label } from './Label';
import { Help } from './Help';
import { Error } from '../error';

export const UrlsInput = ({ value, label, help, onChange, style, ...props }) => {
  const [string, setString] = useState((value || []).join('\n'));
  const [error, setError] = useState();

  useEffect(() => {
    // if (string) {
    //   return;
    // }
    if (!value) {
      return;
    }
    setString(value.join('\n'));
  }, [value]);

  useEffect(() => {
    setError(null);

    const urls = string
      .split('\n')
      .map((it) => it.trim())
      .filter(Boolean);

    if (!urls.length) {
      onChange(null);
      return;
    }

    onChange(urls);

    let invalid = [];
    for (const url of urls) {
      if (url.length <= 10) {
        continue;
      }

      if (!url.startsWith('http')) {
        invalid.push(`URL must start with "http": ${url}`);
      } else {
        try {
          new URL(url);
        } catch {
          invalid.push(`Invalid URL: ${url}`);
        }
      }

      if (invalid.length >= 5) {
        break;
      }
    }

    if (invalid.length) {
      setError(invalid.join(', '));
    } else {
      setError(null);
    }
  }, [string]);

  return (
    <div>
      {label && <Label label={label} />}
      {help && <Help help={help} />}
      <textarea
        style={{
          fontFamily: 'sans-serif',
          padding: '4px 6px',
          width: '100%',
          height: 80,
          whiteSpace: 'nowrap',
          overflow: 'auto',
          border: '1px solid #ccc',
          borderRadius: 5,
          ...(style || {}),
        }}
        value={string}
        onChange={(e) => setString(e.target.value)}
        placeholder={props?.placeholder || 'https://example.com/page-1'}
      />
      <Error small message={error} />
    </div>
  );
};
